// extracted by mini-css-extract-plugin
export var sliderRange = "_r5-2";
export var sliderRoot = "_r5-0";
export var sliderThumb = "_r5-3";
export var sliderTrack = "_r5-1";